module.exports = __webpack_public_path__ + "img/qddt_white.cf682c3a.png";